export default __webpack_public_path__ + "/assets/comefareper2.png";